import {
  container,
  cardTitle,
  whiteColor,
  grayColor,
} from "assets/jss/material-dashboard-react.js";
import modalStyle from "assets/jss/material-dashboard-react/modalStyle.js";

const styles = (theme) => ({
  container: {
    ...container,
    zIndex: "4",
    fontWeight: 400,
    maxWidth: 1800,
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "100px",
    },
  },
  modalContainer: {
    fontWeight: 400,
    maxWidth: 1800,
  },
  content: {
    fontWeight: 400,
    fontSize: 16,
  },
  floatLeft: {
    float: "left",
  },
  floatRight: {
    float: "right",
  },
  floatNone: {
    float: "none",
  },
  alignLeft: {
    textAlign: "left",
  },
  alignRight: {
    textAlign: "right",
  },
  detailsHeader: {
    textAlign: "left",
    marginBottom: 20,
    fontSize: 18,
  },
  detailsRow: {
    marginTop: 10,
    color: "black",
    paddingRight: 15,
  },
  buttonContainer: {
    marginTop: 20,
    marginBottom: 20,
  },
  detailsRowFooter: {
    fontSize: 12,
    textAlign: "left",
  },
  button: {
    marginLeft: 20,
  },
  checkIcon: {
    color: "#A5DC86",
    border: "solid 4px",
    borderRadius: 22,
    padding: 2,
    fontSize: 44,
    borderColor: "aquamarine",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  titleContent: {
    paddingTop: 5,
    paddingLeft: 10,
    fontSize: "xx-large",
  },
  loginModalTitle: {
    fontWeight: 500,
    textAlign: "left",
    color: grayColor[2],
    fontSize: "1.825em",
    lineHeight: "1.5em",
  },
  subTitle: {
    fontWeight: 400,
    fontSize: "16px",
  },
  center: {
    textAlign: "center",
    margin: 20,
    marginTop: 40,
  },
  cardTitle: {
    ...cardTitle,
    marginTop: "0",
    marginBottom: "3px",
    color: grayColor[2],
    fontSize: "18px",
  },
  labelStyle: {
    color: grayColor[1] + " !important",
    fontSize: 14,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1.42857,
    textAlign: "left",
    transform: "none",
  },
  selectLabel: {
    fontSize: 14,
    textTransform: "none",
    color: "#AAAAAA !important",
    //top: 7
  },
  select: {
    paddingBottom: 10,
    fontSize: 14,
  },
  selectFormControl: {
    [theme.breakpoints.up("lg")]: {
      marginTop: -15,
    },
  },
  countryFormControl: {
    marginTop: 5,
  },
  modalCloseButton: {
    float: "right",
  },
  emptyIcon: {
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
  },
  cardSubtitle: {
    color: grayColor[0],
    fontSize: 14,
    margin: "0 0 10px",
  },
  textCenter: {
    textAlign: "center",
  },
  justifyContentCenter: {
    justifyContent: "center !important",
  },
  customButtonClass: {
    "&,&:focus,&:hover": {
      color: whiteColor,
    },
    marginLeft: "5px",
    marginRight: "5px",
  },
  inputAdornment: {
    marginRight: "18px",
  },
  inputAdornmentIcon: {
    borderRadius: 10,
    height: 32,
    backgroundColor: grayColor[0],
    color: "#505050",
    marginLeft: "-40px",
    "&:hover": {
      backgroundColor: grayColor[6],
    },
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)",
  },
  cardHeader: {
    marginBottom: "20px",
    zIndex: "3",
  },
  socialLine: {
    padding: "0.9375rem 0",
  },
  menuPaper: {
    height: "100px !important",
  },
  menu2Paper: {
    height: "250px !important",
  },
  ...modalStyle(theme),
});

export default styles;
